<div mat-dialog-content>
  @if (isFirstLoading) {
    <app-loading-list></app-loading-list>
  }
  @if (!isFirstLoading) {
    <div class="mat-dialog-content">
      <!-- <div class="title-header">
      <div class="row">
        <div class="col-6 col-sm-6 col-md-6">
          <mat-slide-toggle class="indigent-checkbox" [ngModelOptions]="{standalone: true}"
            [(ngModel)]="this.isUnidentifiedPatient" (change)="changeIndigent($event)">Paciente não
          identificado</mat-slide-toggle>
        </div>
      </div>
    </div> -->
    <!-- <mat-form-field appearance="outline">
    <mat-label>Prioridade</mat-label>
    <mat-select formControlName="listIdPriority" multiple #prioritySelect
      (selectionChange)="validatePriorities($event)">
      <mat-option *ngFor="let item of listOfPriorities" [value]="item.idPriority"
        [disabled]="disallowedIdPriorities.includes(item.idPriority)">{{item.priorityName}}
      </mat-option>
    </mat-select>
  </mat-form-field> -->
  <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-6" *ngIf="this.isUnidentifiedPatient">
  <mat-form-field appearance="outline">
    <mat-label>Descrição do paciente não identificado</mat-label>
    <textarea matInput type="text" formControlName="unidentifiedPatientDescription"></textarea>
  </mat-form-field>
</div> -->
@if (this.isUnidentifiedPatient && this.episodeStruct) {
  <div>
    <div class="section-container">
      <div class="title-header">
        <h1>Dados Pessoais</h1>
      </div>
      @if (listPriorityEpisode && listPriorityEpisode.length > 0) {
        <div class="priorities">
          <span class="label-priority"><b>Prioridade: </b></span>
          @for (priority of this.listPriorityEpisode; track priority) {
            <span class="icon">
              @if (priority.idPriority !== this.overEightyYearsEnum && priority.idPriority !== this.overSixtyYearsEnum && priority.idPriority !== this.autismEnum) {
                <mat-icon
                >{{priority.icon}}</mat-icon>
              }
              @if (priority.idPriority === this.autismEnum) {
                <img src="assets/images/autism-symbol.png" class="img-adjust"
                  />
              }
              @if (priority.idPriority === this.overEightyYearsEnum || priority.idPriority === this.overSixtyYearsEnum) {
                <span
                >{{priority.icon}}</span>
              }
            </span>
          }
        </div>
      }
      @if (episodeStruct.unidentifiedPatientDescription) {
        <div>
          <span><b>Descrição do paciente não identificado: </b></span>
          <span>{{episodeStruct.unidentifiedPatientDescription}}</span>
        </div>
      }
    </div>
  </div>
}
@if (!this.isUnidentifiedPatient && this.patient) {
  <div>
    <div class="section-container">
      <div class="title-header">
        <h1>Dados Pessoais</h1>
      </div>
      <div class="row section-personal-data">
        @if (patient.socialName) {
          <div>
            <span><b>Nome Social: </b></span>
            <span>{{patient.socialName}}</span>
          </div>
        }
        @if (patient.patientName) {
          <div>
            <span><b>Nome: </b></span>
            <span>{{patient.patientName}}</span>
          </div>
        }
        @if (patient.birthDate) {
          <div>
            <span><b>Data de Nascimento: </b></span>
            <span>{{patient.birthDate | date: 'dd/MM/yyyy'}}</span>
          </div>
        }
        @if (patient.birthDate) {
          <div>
            <span><b>Idade: </b></span>
            <span>{{this.patientAge}}</span>
          </div>
        }
        <!-- Antigo Gênero -->
        @if (patient.genderName) {
          <div>
            <span><b>Sexo: </b></span>
            <span>{{patient.genderName}}</span>
          </div>
        }
        @if (patient.genderIdentityName) {
          <div>
            <span><b>Gênero: </b></span>
            <span>{{patient.genderIdentityName}}</span>
          </div>
        }
        @if (patient.cpf) {
          <div>
            <span><b>CPF: </b></span>
            <span>{{patient.cpf}}</span>
          </div>
        }
        @if (patient.cns) {
          <div>
            <span><b>CNS: </b></span>
            <span>{{patient.cns}}</span>
          </div>
        }
        @if (patient.phone1) {
          <div>
            <span><b>Telefone 1: </b></span>
            <span>{{patient.phone1}}</span>
          </div>
        }
        @if (patient.phone2) {
          <div>
            <span><b>Telefone 2: </b></span>
            <span>{{patient.phone2}}</span>
          </div>
        }
        @if (patient.raceName) {
          <div>
            <span><b>Raça: </b></span>
            <span>{{patient.raceName}}</span>
          </div>
        }
        @if (patient.educationName) {
          <div>
            <span><b>Escolaridade: </b></span>
            <span>{{patient.educationName}}</span>
          </div>
        }
        @if (patient.motherName) {
          <div>
            <span><b>Nome da Mãe: </b></span>
            <span>{{patient.motherName}}</span>
          </div>
        }
        @if (patient.fatherName) {
          <div>
            <span><b>Nome do Pai: </b></span>
            <span>{{patient.fatherName}}</span>
          </div>
        }
        @if (patient.profession) {
          <div>
            <span><b>Profissão: </b></span>
            <span>{{patient.profession}}</span>
          </div>
        }
        @if (patient.rg) {
          <div>
            <span><b>RG: </b></span>
            <span>{{patient.rg}}</span>
          </div>
        }
        @if (patient.expeditionIssuer) {
          <div>
            <span><b>Órgão Expeditor: </b></span>
            <span>{{patient.expeditionIssuer}}</span>
          </div>
        }
        @if (patient.expeditionDate) {
          <div>
            <span><b>Data de Expedição: </b></span>
            <span>{{patient.expeditionDate | date: 'dd/MM/yyyy'}}</span>
          </div>
        }
        @if (patient.maritalStatusName) {
          <div>
            <span><b>Estado Civil: </b></span>
            <span>{{patient.maritalStatusName}}</span>
          </div>
        }
        @if (listPriorityEpisode && listPriorityEpisode.length > 0) {
          <div class="priorities">
            <span class="label-priority"><b>Prioridade: </b></span>
            @for (priority of this.listPriorityEpisode; track priority) {
              <span class="icon">
                @if (priority.idPriority !== this.overEightyYearsEnum && priority.idPriority !== this.overSixtyYearsEnum && priority.idPriority !== this.autismEnum && priority.idPriority === prioritiesStatusEnum.lactante) {
                  <mat-icon
                  >{{priority.icon}}</mat-icon>
                }
                @if (priority.idPriority === this.autismEnum) {
                  <img src="assets/images/autism-symbol.png" class="img-adjust"
                    />
                }
                @if (priority.idPriority === this.overEightyYearsEnum || priority.idPriority === this.overSixtyYearsEnum) {
                  <span
                  >{{priority.icon}}</span>
                }
                @if (priority.idPriority === prioritiesStatusEnum.lactante) {
                  <span class="icon material-symbols-outlined">{{priority.icon}}</span>
                }
              </span>
            }
          </div>
        }
        @if (patient.birthCountry) {
          <div>
            <span><b>Nacionalidade: </b></span>
            <span>{{patient.birthCountry}}</span>
          </div>
        }
        @if (patient.birthState) {
          <div>
            <span><b>Estado de Origem: </b></span>
            <span>{{patient.birthState}}</span>
          </div>
        }
        @if (patient.birthCity) {
          <div>
            <span><b>Cidade de Origem: </b></span>
            <span>{{patient.birthCity}}</span>
          </div>
        }
      </div>
    </div>
    @if (this.showSectionAddress) {
      <div class="section-container">
        <div class="title-header">
          <h1>Endereço</h1>
        </div>
        <div class="row section-address">
          @if (patient.zipCode) {
            <div>
              <span><b>CEP: </b></span>
              <span>{{patient.zipCode}}</span>
            </div>
          }
          @if (patient.street) {
            <div>
              <span><b>Logradouro: </b></span>
              <span>{{patient.street}}</span>
            </div>
          }
          @if (patient.houseNumber) {
            <div>
              <span><b>Número: </b></span>
              <span>{{patient.houseNumber}}</span>
            </div>
          }
          @if (patient.apartmentNumber) {
            <div>
              <span><b>Complemento: </b></span>
              <span>{{patient.apartmentNumber}}</span>
            </div>
          }
          @if (patient.neighborhood) {
            <div>
              <span><b>Bairro: </b></span>
              <span>{{patient.neighborhood}}</span>
            </div>
          }
          @if (patient.city) {
            <div>
              <span><b>Cidade: </b></span>
              <span>{{patient.city}}</span>
            </div>
          }
          @if (patient.state) {
            <div>
              <span><b>Estado: </b></span>
              <span>{{patient.state}}</span>
            </div>
          }
          @if (patient.country) {
            <div>
              <span><b>País: </b></span>
              <span>{{patient.country}}</span>
            </div>
          }
        </div>
      </div>
    }
    @if (this.showSectionOrigin) {
      <div class="section-container">
        <div class="title-header">
          <h1>Procedência</h1>
        </div>
        <div class="row section-origin">
          @if (patient.originName) {
            <div>
              <span><b>Origem: </b></span>
              <span>{{patient.originName}}</span>
            </div>
          }
          @if (patient.arrivalTypeName) {
            <div>
              <span><b>Tipo de chegada: </b></span>
              <span>{{patient.arrivalTypeName}}</span>
            </div>
          }
          @if (this.patient.listPatientNecessities && this.patient.listPatientNecessities.length > 0) {
            <div>
              <span><b>Necessidades do paciente: </b></span>
              <span>{{this.patientNecessities}}</span>
            </div>
          }
          @if (patient.observation) {
            <div>
              <span><b>Observação: </b></span>
              <span>{{patient.observation}}</span>
            </div>
          }
        </div>
      </div>
    }
    @if (this.showSectionCompanion) {
      <div class="section-container">
        <div class="title-header">
          <h1>Acompanhante</h1>
        </div>
        <div class="row section-companion">
          @if (patient.companionName) {
            <div>
              <span><b>Nome: </b></span>
              <span>{{patient.companionName}}</span>
            </div>
          }
          @if (patient.companionPhone) {
            <div>
              <span><b>Telefone: </b></span>
              <span>{{patient.companionPhone}}</span>
            </div>
          }
          @if (patient.companionCpf) {
            <div>
              <span><b>CPF: </b></span>
              <span>{{patient.companionCpf}}</span>
            </div>
          }
          @if (patient.companionParentage) {
            <div>
              <span><b>Parentesco: </b></span>
              <span>{{patient.companionParentage}}</span>
            </div>
          }
        </div>
      </div>
    }
    @if (this.lastTriage) {
      <div class="section-container">
        <div class="title-header">
          <h1>Última Triagem</h1>
        </div>
        <div class="row section-origin">
          <app-triage-resume [triage]="lastTriage" [isHistorical]="true"></app-triage-resume>
        </div>
      </div>
    }
    @if (this.listValuePatientMetaData && this.listValuePatientMetaData.length > 0) {
      <div class="section-container">
        <div class="title-header">
          <h1>Dados Adicionais</h1>
        </div>
        <div class="row">
          @for (item of listValuePatientMetaData; track item) {
            <div>
              <span><b>{{item.name}}: </b></span>
              @if (item.id != metaDataTypeEnum.Data) {
                <span>{{item.value}}</span>
              }
              @if (item.id == metaDataTypeEnum.Data) {
                <span>{{item.value | date: 'dd/MM/yyyy'}}</span>
              }
            </div>
          }
        </div>
      </div>
    }
    @if (this.data.selfTriage?.errorDescription == null && this.data.selfTriage?.listQuestionAnswer?.length > 0) {
      <div
        class="section-container">
        <div class="title-header">
          <h1>Autotriagem</h1>
        </div>
        <div class="row section-personal-data">
          <span class="margin-bottom"><b>Fluxograma: </b>{{this.data.selfTriage.patientFlowchart.flowchart}}</span>
          @for (item of this.data.selfTriage.listQuestionAnswer; track item; let i = $index) {
            <div class="row">
              <div class="row">
                <span><b>{{i + 1}}- Pergunta: </b>{{item.statement}}</span>
                <li class="margin-left"><b>Resposta: </b>{{item.answer}}</li>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
</div>
}
</div>
<div mat-dialog-footer class="footer-modal">
  @if (isLoading == false) {
    <div class="col-12 col-md-4">
      <button mat-flat-button type="button" color="accent" class="btn-block" (click)="closeModal()">
        <span>Fechar</span>
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
  }
</div>